<template>
  <v-dialog
    :value="open"
    persistent
    max-width="350"
    content-class="request-field-item-dialog"
  >
    <v-card color="#f0f0ef" class="home-form-container">
      <v-card-text
        class="home-form-container"
        style="text-align: left; padding: 4px 0 0 0; overflow: visible"
      >
        <input-field
          :label="$tc('Code', 1)"
          v-model="listValueData.code"
          input-type="text"
          min="0"
          :required="true"
          size="100"
          :badLabel="checkCode"
          limit="32"
          @check-alphanumeric="checkAlphanumeric"
        />

        <input-field
          :label="$tc('Label', 1)"
          v-model="listValueData.libelle"
          size="100"
          max-length="255"
          input-type="text"
          :badLabel="checkLabel"
          limit="255"
          :required="true"
        />

        <input-field
          v-if="!isCustomList"
          :label="$t('ClientCode')"
          v-model="listValueData.client_code"
          max="3"
          size="100"
          input-type="text"
        />

        <input-field
          v-if="!isCustomList"
          :label="$t('ClientLabel')"
          v-model="listValueData.client_label"
          size="100"
          input-type="text"
        />

        <input-field
          v-if="!isCustomList"
          :label="$t('Definition')"
          v-model="listValueData.definition"
          size="100"
          input-type="text"
        />

        <input-field
          :label="$t('Index')"
          v-model="listValueData.index"
          size="100"
          input-type="int"
          min="0"
        />

        <div v-if="!isCustomList" class="input-field">
          <label for="deleted">
            {{ $t("Blocked") }}
          </label>
          <v-radio-group
            id="deleted"
            v-model="listValueData.blocked"
            mandatory
            row
          >
            <v-radio
              :label="$t('Yes')"
              :value="true"
              :ripple="false"
              color="accent"
            />
            <v-radio
              :label="$t('No')"
              :value="false"
              :ripple="false"
              color="accent"
            />
          </v-radio-group>
        </div>

        <div v-if="!isCustomList" class="input-field">
          <label for="deleted">
            {{ $t("Hidden") }}
          </label>
          <v-radio-group
            id="deleted"
            v-model="listValueData.deleted"
            mandatory
            row
          >
            <v-radio
              :label="$t('Yes')"
              :value="true"
              :ripple="false"
              color="accent"
            />
            <v-radio
              :label="$t('No')"
              :value="false"
              :ripple="false"
              color="accent"
            />
          </v-radio-group>
        </div>
      </v-card-text>

      <v-card-actions style="padding-right: 20px; padding-bottom: 12px">
        <v-spacer />
        <management-button
          type="cancel"
          :label="$t('Cancel')"
          @buttonClick="close"
        />
        <management-button
          type="execute"
          :label="$t('Create')"
          :disabled="!requiredAreFilled"
          @buttonClick="applyChanges"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import InputField from "@/components/Home/Forms/_Molecules/InputField";
import ManagementButton from "@/components/Management/ManagementButton";

export default {
  name: "ListItemPopupForm",

  components: {
    InputField,
    ManagementButton
  },

  mixins: [checkPermissionsMixin],

  props: {
    /**
     * Maximum length of the code field
     */
    characterMaximumLength: {
      type: Number
    },

    /**
     * Input type of the code field
     */
    inputType: {
      type: String
    },

    /**
     * Defines if the dialog box is open or not.
     */
    open: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      /**
       * Data of the list item
       */
      listValueData: {
        code: null,
        libelle: null,
        client_code: null,
        client_label: null,
        definition: null,
        index: null,
        blocked: false,
        deleted: false
      }
    };
  },

  computed: {
    /**
     * Indicates if the required fields are filled
     * Verifies if the code field is a valid string
     * @return {Boolean}
     */
    requiredAreFilled() {
      if(this.codeIsValid && this.labelIsValid){
        return this.codeIsValid.length <= 32 && this.labelIsValid.length <= 255;
      }else{
        return false;
      }
    },
    checkCode(){
      if(this.listValueData.code){
        return this.checkLimit(this.listValueData.code,32);
      }
    },
    checkLabel(){
      if(this.listValueData.libelle){
        return this.checkLimit(this.listValueData.libelle,255);
      }
    },
    /**
     * Indicates if the code is valid
     * @return {Boolean}
     */
    codeIsValid() {
      return this.listValueData.code && this.listValueData.code.trim();
    },

    /**
     * Indicates if the label is valid
     * @return {Boolean}
     */
    labelIsValid() {
      return this.listValueData.libelle && this.listValueData.libelle.trim();
    },

    /**
     * Indicates if the list is custom or not
     */
    isCustomList() {
      return (
        this.$route.name === "custom-list-create" ||
        this.$route.params.isCustomList
      );
    },

    /**
     * Boolean radio options
     */
    booleanOptions() {
      return [
        { value: true, label: this.$i18n.t("Yes") },
        { value: false, label: this.$i18n.t("No") }
      ];
    }
  },

  methods: {
    /**
     * Closes the form and clears the data of the list item
     */
    close() {
      this.$emit("close");
      this.resetValues();
    },

    /**
     * Verifies if the required fields are filled and if so, emits an event to the parent component to
     * add the new item to the list of items
     * Also clears the list item data
     */
    applyChanges() {
      if (this.requiredAreFilled) {
        this.$emit("add", this.listValueData);
        this.resetValues();
      }
    },

    resetValues() {
      this.listValueData.code = null;
      this.listValueData.libelle = null;
      (this.listValueData.client_code = null),
        (this.listValueData.client_label = null),
        (this.listValueData.definition = null),
        (this.listValueData.index = null),
        (this.listValueData.blocked = false),
        (this.listValueData.deleted = false);
    },
  }
};
</script>

<style scoped>
.request-field-item-dialog {
  overflow-y: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/ListItemPopupForm.vue